// extracted by mini-css-extract-plugin
module.exports = {"header":"infoStop_header__2Q3Xw","div":"infoStop_div__1ZBZh","link":"infoStop_link__1IidV","lines":"infoStop_lines__O1wDZ","time":"infoStop_time__2uU3U"};